import styled from '@emotion/styled';

export const MenuDotsWrapper = styled.span`
  display: inline-block;
  height: 24px;
  width: 24px;
  padding: 4px;
  position: absolute;
  top: 0;
  ${props => props.theme.isRTL ? 'left' : 'right'}: 0;
  border-radius: ${({ theme }) => theme.borderRadius.round};
  background-color: transparent;
  path {
    fill: ${({ theme }) => theme.colors.neutrals.grey3};
  }

  ${props => props.theme.media.showAt({ from: 3 })`
    &:hover {
      background: ${props.theme.colors.neutrals.grey9};
    }
  `}
`;

export const DropdownWrapper = styled.div`
  position: relative;
`;
